module.exports = __webpack_public_path__ + "static/assets/e37886ef88fd18af156bb47c45a3cd12.svg";